// import React from 'react'
import { TextField } from './TextField'
// import { FormItem } from './FormItem'
import { formatDigits } from '../Utility'

export function isAcn(acn: string) {
  var weights = [8, 7, 6, 5, 4, 3, 2, 1]

  var digits = acn.replace(/[^\d]/g, '').split('').map(Number)

  if (digits.length != 9)
    return false

  var sum = 0
  let temp = digits.slice(0, 8) 

  for (let i = 0; i < temp.length; i++) {
    sum = sum + temp[i] * weights[i]
  }

  var lastDigit = 10 - sum % 10
  if (lastDigit == 10)
    lastDigit = 0

  if (lastDigit === digits[8])
    return true

  return false
}

export class AcnField extends TextField {
  getErrorText(): string {
    let error = super.getErrorText()
    if (error) {
      return error
    }

    if (this.hasValue()) {
      if (!isAcn(this.getValue())) {
        return 'ACN invalid'
      }
    }

    return null
  }

  onBlurHandler(v: string) {
    super.onBlurHandler(formatDigits(v))
  }
}
